
import React from 'react';
import { Diamond, Trophy, Crown, Star, Shield } from 'lucide-react';

const PainPoints = () => {
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="w-full h-full" 
          style={{
            backgroundImage: "linear-gradient(45deg, #004080 1px, transparent 1px), linear-gradient(-45deg, #004080 1px, transparent 1px)",
            backgroundSize: "30px 30px"
          }}>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-serif">
            The Essence of Luxury Care
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Gold Standard Cleaning Group understands the unique requirements of maintaining prestigious properties. Our services are tailored to exceed the expectations of the most discerning clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <Diamond className="h-8 w-8 text-navy" />
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center">Premium Service</h3>
            <p className="text-gray-600">
              Our white-glove service ensures meticulous attention to every detail, preserving the elegance of your luxury residence.
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <Trophy className="h-8 w-8 text-navy" />
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center">Elite Standards</h3>
            <p className="text-gray-600">
              Gold Standard Cleaning Group maintains the highest standards of service, ensuring your home reflects the sophistication and refinement it deserves.
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <Crown className="h-8 w-8 text-navy" />
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center">Bespoke Solutions</h3>
            <p className="text-gray-600">
              Each service is customized to your specific preferences, schedule, and the unique requirements of your luxury property.
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <Star className="h-8 w-8 text-navy" />
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center">Exclusive Care</h3>
            <p className="text-gray-600">
              Our vetted professionals are trained to handle high-end materials, fine furnishings, and valuable decor with expert care.
            </p>
          </div>

          <div className="bg-gray-50 p-8 rounded-lg border border-gray-100 hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-navy/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <Shield className="h-8 w-8 text-navy" />
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center">Absolute Discretion</h3>
            <p className="text-gray-600">
              Your privacy is Gold Standard Cleaning Group's highest priority. We operate with complete confidentiality, ensuring that every service visit protects the sanctity, security, and personal life of your residence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;
